import { useState } from "react";
import { Download, Image as ImageIcon, Copy, Check } from "lucide-react";

const BILDTEXT = `Mise en place für heute Abend.

Sechs Gänge, handgeschrieben auf der Karte, hausgebackenes Sauerteigbrot, geschmorter Kürbis, Tagliolini al Limone, Rinderfilet und zum Schluss Quitte & Zwetschge.

Gekocht wird dort, wo gegessen wird: bei meinen Gästen zu Hause. Ich bringe Küche, Handwerk und Ruhe mit — ihr bleibt am Tisch sitzen.

Termin für Euren Abend? Schreibt mir einfach.
stutz-cuisine.com

#privatkoch #mietkoch #dinnerathome #odenwald #michelstadt #erbach #finedining #menüabend #sauerteig #kochenmitliebe #privatdinner #eventkoch #hessen #bergstraße`;

export default function ReelSeite() {
  const [kopiert, setKopiert] = useState(false);

  const kopieren = async () => {
    try {
      await navigator.clipboard.writeText(BILDTEXT);
      setKopiert(true);
      setTimeout(() => setKopiert(false), 2500);
    } catch { /* Browser erlaubt kein Kopieren — Text lässt sich markieren */ }
  };

  return (
    <div className="min-h-screen bg-[#FAFAF7] py-14 px-6" data-testid="reel-seite">
      <div className="max-w-4xl mx-auto">
        <p className="text-[10px] uppercase tracking-[0.25em] text-[#BA6D52]">Für Instagram &amp; Facebook</p>
        <h1 className="font-serif text-4xl sm:text-5xl text-[#2C2A26] mt-3">Reel: Kulinarischer Dinner-Abend</h1>

        <div className="grid grid-cols-1 md:grid-cols-[320px_1fr] gap-8 mt-10 items-start">
          <div>
            <video src="/reel-dinner-abend.mp4" poster="/reel-cover.jpg" controls playsInline
              data-testid="reel-player"
              className="w-full border border-[#E3DECE] bg-black" />
            <div className="flex flex-wrap gap-2 mt-4">
              <a href="/reel-dinner-abend.mp4" download="Reel-Dinner-Abend.mp4" data-testid="reel-download"
                className="inline-flex items-center gap-2 bg-[#BA6D52] hover:bg-[#A55C43] text-white text-[10px] uppercase tracking-[0.18em] px-4 py-3 transition-colors">
                <Download size={14} /> Video laden
              </a>
              <a href="/reel-cover.jpg" download="Reel-Cover.jpg" data-testid="reel-cover-download"
                className="inline-flex items-center gap-2 border border-[#BA6D52] text-[#BA6D52] hover:bg-[#FAF5F1] text-[10px] uppercase tracking-[0.18em] px-4 py-3 transition-colors">
                <ImageIcon size={14} /> Cover laden
              </a>
            </div>
            <p className="text-xs text-[#757067] mt-3">15 Sekunden · 1080 × 1920 · ohne Ton</p>
          </div>

          <div className="space-y-4 text-[#575249]">
            <p className="text-base">
              Zuerst die Menükarte als sauber gesetzte Titelkarte mit dem LS-Monogramm, dann Dein
              Material in warmem Licht — eng auf Teller, Karte und Gewürzglas, damit vom Fenster und
              der Deko dahinter nichts mehr zu sehen ist. Dazu die Einblendungen „Mise en place" und
              „Gleich wird angerichtet", zum Schluss der Abspann mit Kontakt.
            </p>
            <p className="text-base">
              <b>Kein Ton:</b> So kannst Du in Instagram direkt einen Trending-Sound drüberlegen — das
              bringt in Reels deutlich mehr Reichweite als eigene Musik.
            </p>
            <h2 className="font-serif text-2xl text-[#2C2A26] pt-2">So lädst Du es hoch</h2>
            <ol className="list-decimal pl-5 space-y-1.5 text-base">
              <li>„Video laden" am Handy antippen — die Datei landet in Downloads bzw. Fotos.</li>
              <li>Instagram → <b>Reel</b> → Video auswählen → Sound aus den Vorschlägen hinzufügen.</li>
              <li>Für die <b>Story</b> dasselbe Video nehmen und als Story posten.</li>
              <li>Auf Facebook beim Hochladen gleich mit teilen.</li>
            </ol>
          </div>
        </div>

        <h2 className="font-serif text-2xl text-[#2C2A26] mt-12">Bildtext zum Kopieren</h2>
        <textarea readOnly value={BILDTEXT} rows={12} data-testid="reel-caption"
          className="w-full border border-[#E3DECE] bg-white p-4 text-sm mt-3" />
        <button onClick={kopieren} data-testid="reel-caption-copy"
          className="mt-3 inline-flex items-center gap-2 bg-[#BA6D52] hover:bg-[#A55C43] text-white text-[10px] uppercase tracking-[0.18em] px-4 py-3 transition-colors">
          {kopiert ? <Check size={14} /> : <Copy size={14} />} {kopiert ? "Kopiert" : "Bildtext kopieren"}
        </button>

        <div className="mt-12 border-l-2 border-[#BA6D52] bg-[#FAF5F1] px-5 py-4">
          <p className="text-sm text-[#575249]">
            <b>Tipp:</b> Die Story direkt vor dem Einsatz posten, das Reel am Tag danach mit einem Bild
            vom fertigen Teller — dieselbe Titelkarte hält beides optisch zusammen.
          </p>
        </div>
      </div>
    </div>
  );
}
